import api from '../../store/config/api';
import {
  PREDICTOR as SCHEMA,
  PROCESS_LIST as PROCESS_LIST_SCHEMA
} from '../../schemas';

export const [
  GET_PREDICTOR,
  GET_PREDICTOR_REQUEST,
  GET_PREDICTOR_SUCCESS,
  GET_PREDICTOR_FAILURE
] = api.buildTypes('GET_PREDICTOR');

export function getPredictor({ teamName, predictorID }) {
  return {
    type: GET_PREDICTOR,
    payload: {
      url: `/teams/${teamName}/predictors/${predictorID}`,
      schema: SCHEMA
    }
  };
}

export const [
  CREATE_PREDICTOR,
  CREATE_PREDICTOR_REQUEST,
  CREATE_PREDICTOR_SUCCESS,
  CREATE_PREDICTOR_FAILURE
] = api.buildTypes('CREATE_PREDICTOR');

export function createPredictor({
  teamName,
  tableID,
  dependentFieldName,
  displayName,
  type = 'binary'
}) {
  return {
    type: CREATE_PREDICTOR,
    payload: {
      options: {
        method: 'POST',
        body: {
          teamName,
          tableID,
          dependentFieldName,
          displayName,
          type
        }
      },
      url: `/teams/${teamName}/predictors`,
      schema: SCHEMA
    }
  };
}

export const [
  UPDATE_PREDICTOR,
  UPDATE_PREDICTOR_REQUEST,
  UPDATE_PREDICTOR_SUCCESS,
  UPDATE_PREDICTOR_FAILURE
] = api.buildTypes('UPDATE_PREDICTOR');

export function updatePredictor({
  teamName,
  predictorID,
  tableID,
  dependentFieldName,
  displayName,
  type
}) {
  return {
    type: UPDATE_PREDICTOR,
    payload: {
      options: {
        method: 'POST',
        body: {
          teamName,
          tableID,
          dependentFieldName,
          displayName,
          type
        }
      },
      url: `/teams/${teamName}/predictors/${predictorID}`,
      schema: SCHEMA
    }
  };
}

export const [
  DELETE_PREDICTOR,
  DELETE_PREDICTOR_REQUEST,
  DELETE_PREDICTOR_SUCCESS,
  DELETE_PREDICTOR_FAILURE
] = api.buildTypes('DELETE_PREDICTOR');

export function deletePredictor({ teamName, predictorID }) {
  return {
    type: DELETE_PREDICTOR,
    predictorID,
    payload: {
      options: { method: 'DELETE' },
      url: `/teams/${teamName}/predictors/${predictorID}`,
      schema: SCHEMA
    }
  };
}

export const [
  GET_PREDICTOR_PROCESSES,
  GET_PREDICTOR_PROCESSES_REQUEST,
  GET_PREDICTOR_PROCESSES_SUCCESS,
  GET_PREDICTOR_PROCESSES_FAILURE
] = api.buildTypes('GET_PREDICTOR_PROCESSES');

export function getPredictorProcesses({ teamName, predictorID }) {
  return {
    type: GET_PREDICTOR_PROCESSES,
    payload: {
      url: `/teams/${teamName}/predictors/${predictorID}/parentprocesses`,
      schema: PROCESS_LIST_SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/predictor.js